<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="epigraph2" style="margin-top:30px;"><i>quest:</i> a chivalrous enterprise in medieval romance usually involving an adventurous journey.</p>
<blockquote>
<p class="noind"><i>—Webster’s Third New International</i></p>
<p class="noind"><i>Dictionary</i></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-epigraph2.vue?3649f93e